import React, { useEffect, useState, useRef, useContext } from 'react'
import { GlobalContext } from '../Store/GlobalContext'
import { ForgotPasswordEmailStep } from './ForgotPasswordEmailStep'
import { ForgotPasswordConfirmStep } from './ForgotPasswordConfirmStep'
import '../assets/Components/Login/Login.css'

export const ForgotPasswordFormParent = ( props ) => {

    const [ emailError, setEmailError ] = useState('')
    const [ email , setEmail ] = useState('')
    const [ step, setStep ] = useState(1)


    const renderFormScreen = (formStep) => {
        switch(formStep) {
            case 1:
                return <ForgotPasswordEmailStep setStep={setStep}/>;
            case 2:
                return <ForgotPasswordConfirmStep />;
            default:
                return <ForgotPasswordEmailStep setStep={setStep}/>;
          }
    }

    return (

        <div id="floify-login-page">
            {renderFormScreen(step)}
        </div>

    )
}